import CallEndRoundedIcon from '@mui/icons-material/CallEndRounded'
import CallRoundedIcon from '@mui/icons-material/CallRounded'
import PhoneCallbackRoundedIcon from '@mui/icons-material/PhoneCallbackRounded'
import { Box, Button, Stack, Typography } from '@mui/material'

// Incoming-call banner pinned top-center. Shown when an inbound signal arrives while the agent is
// available. Accept opens the call surface for the caller; reject dismisses.
export default function SupportCallInboundBanner({ incoming, onAccept, onReject }) {
  if (!incoming) {
    return null
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1400,
        width: 360,
        maxWidth: 'calc(100vw - 32px)',
        borderRadius: '18px',
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        border: '1px solid rgba(226, 232, 240, 0.9)',
        boxShadow: '0 22px 52px rgba(15, 23, 42, 0.26)',
        animation: 'supportInboundIn 220ms ease',
        '@keyframes supportInboundIn': {
          from: { transform: 'translate(-50%, -12px)', opacity: 0 },
          to: { transform: 'translate(-50%, 0)', opacity: 1 },
        },
      }}
    >
      <Stack direction="row" spacing={1.25} alignItems="center" sx={{ px: 2, py: 1.5 }}>
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: '14px',
            display: 'grid',
            placeItems: 'center',
            color: '#fff',
            background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
            flexShrink: 0,
            animation: 'supportInboundRing 1.2s ease-in-out infinite',
            '@keyframes supportInboundRing': {
              '0%, 100%': { transform: 'rotate(0deg)' },
              '25%': { transform: 'rotate(-12deg)' },
              '75%': { transform: 'rotate(12deg)' },
            },
          }}
        >
          <PhoneCallbackRoundedIcon />
        </Box>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography sx={{ fontSize: 10.5, fontWeight: 800, letterSpacing: '0.08em', color: '#059669' }}>
            INCOMING CALL
          </Typography>
          <Typography sx={{ fontSize: 15, fontWeight: 800, color: '#0f172a', lineHeight: 1.2 }} noWrap>
            {incoming?.callerName || 'Incoming caller'}
          </Typography>
          <Typography sx={{ fontSize: 12, color: '#64748b' }} noWrap>
            {[incoming?.maskedNumber, incoming?.clinicBrandName].filter(Boolean).join(' · ') || 'Unknown number'}
          </Typography>
        </Box>
      </Stack>
      <Stack direction="row" spacing={1} sx={{ px: 2, pb: 1.75 }}>
        <Button
          fullWidth
          variant="outlined"
          color="error"
          startIcon={<CallEndRoundedIcon />}
          onClick={() => onReject?.(incoming)}
          sx={{ textTransform: 'none', fontWeight: 800, borderRadius: '12px' }}
        >
          Decline
        </Button>
        <Button
          fullWidth
          variant="contained"
          startIcon={<CallRoundedIcon />}
          onClick={() => onAccept?.(incoming)}
          sx={{
            textTransform: 'none',
            fontWeight: 800,
            borderRadius: '12px',
            background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
            '&:hover': { background: 'linear-gradient(135deg, #047857 0%, #065f46 100%)' },
          }}
        >
          Accept
        </Button>
      </Stack>
    </Box>
  )
}
